import { Text } from 'component-library';
import React from 'react';

export const OnDeliveryContent = () => {
  return (
    <Text>We’ll charge you when we deliver your final credit documents.</Text>
  );
};
